import { render, staticRenderFns } from "./ArticleTable.vue?vue&type=template&id=35bd6e34&scoped=true"
import script from "./ArticleTable.vue?vue&type=script&lang=js"
export * from "./ArticleTable.vue?vue&type=script&lang=js"
import style0 from "./ArticleTable.vue?vue&type=style&index=0&id=35bd6e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd6e34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VDataTable,VIcon,VImg,VRow,VScrollXTransition})
